<template>
  <div>
    <Container class="md:m-0 mx-auto btc-address-container">
      <template #header>
        <div class="header-title">
          {{ $t("History") }}
        </div>
      </template>
      <template #body>
        <template v-if="!loading">
          <div class="w-full">
            <transaction-card
              v-for="(transaction, index) in data"
              :key="index"
              :item="parseTransaction(transaction)"
              class="mb-2"
            />
            <div class="show-more-container" v-if="hasMore">
              <BaseButton @click="onLoadMore" v-if="!isLoading" type="shade">
                {{ $t("PaginationButton | ShowMore") }}
              </BaseButton>
              <BaseLoading v-if="isLoading" duration="1000" />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="flex flex-col gap-2 w-full">
            <base-skeleton
              v-for="skeleton in 20"
              :key="skeleton"
              class="w-full h-[198px] first:mt-4 mt-2 rounded-md"
            />
          </div>
        </template>
      </template>
    </Container>
  </div>
</template>

<script setup>
import TransactionCard from "@/entities/transaction-card/ui/index.vue";
import { Container, BaseButton, BaseLoading } from "@/shared/ui";
import BaseSkeleton from "@/shared/ui/BaseSkeleton/BaseSkeleton.vue";

import { formatDate } from "@/shared/utils/format";

defineProps({
  data: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: true,
  },
  // Флаг, указывающий, есть ли еще данные для загрузки
  hasMore: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["load-more"]);
const onLoadMore = () => {
  emit("load-more");
};

function parseTransaction(transactionItem) {
  if (!transactionItem) throw new Error("Error parsing transaction data");

  const { block, status, direction, network, hash, total_output, total_input } =
    transactionItem;

  // Determine the correct amount details object based on direction
  let amountDetails = null;
  if (direction === "incoming" || direction === "self") {
    // Use total_output for both incoming and self transactions
    amountDetails = total_output;
  } else if (direction === "outgoing") {
    amountDetails = total_input;
  }

  return {
    timestamp: formatDate(block?.timestamp),
    hash: hash, // Use transaction hash
    amountDetails: amountDetails, // Pass the structured amount data
    confirmationCount: status?.confirmations,
    confirmed: status?.confirmed,
    network,
    direction,
  };
}
</script>

<style scoped lang="scss">
.show-more-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 16px;
}

.arrow {
  transition: transform 0.3s ease;
  transform: rotate(90deg);
  width: 16px;
  height: 16px;
}

.btc-address-container {
  gap: 24px;
  :deep(.container_body) {
    border-top: none;
  }

  @media (max-width: 768px) {
    padding: 20px 10px;
    gap: 20px;
  }
}

.header-title {
  width: 100%;
  padding-bottom: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  border-bottom: 1px solid #d0d0d012;

  @media (max-width: 768px) {
    padding-bottom: 16px;
  }
}
</style>
